'use strict';

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// Polyfill localStorage/sessionStorage for node test environment
if (typeof localStorage === 'undefined') {
  var _storage = {};
  global.localStorage = {
    getItem: function(key) { return _storage.hasOwnProperty(key) ? _storage[key] : null; },
    setItem: function(key, value) { _storage[key] = String(value); },
    removeItem: function(key) { delete _storage[key]; },
    clear: function() { _storage = {}; },
  };
}
if (typeof sessionStorage === 'undefined') {
  var _sessionStore = {};
  global.sessionStorage = {
    getItem: function(key) { return _sessionStore.hasOwnProperty(key) ? _sessionStore[key] : null; },
    setItem: function(key, value) { _sessionStore[key] = String(value); },
    removeItem: function(key) { delete _sessionStore[key]; },
    clear: function() { _sessionStore = {}; },
  };
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 227
// module chunks = 0